document.addEventListener("DOMContentLoaded", function () {
  console.log("Ultimate Buy Box: Initialized (Cart Payload Fixed Version)");

// --- 1. PRODUCT SWITCHER (MENS / KIDS) ---
  const productSwitcher = document.querySelectorAll(`[data-product-toggle]`);
  productSwitcher.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const productId = button.getAttribute("data-product-toggle");
      
      // Hide all sections, show the target section
      document.querySelectorAll(`.product-section[data-section-id]`).forEach((section) => {
        section.classList.add("tw-hidden");
      });
      document.querySelector(`[data-section-id="${productId}"]`).classList.remove("tw-hidden");

      // Update ALL switcher buttons globally to keep them perfectly in sync
      productSwitcher.forEach(btn => {
        if (btn.getAttribute("data-product-toggle") === productId) {
          // This is the active tab
          btn.classList.add('tw-border-[#1c1d1d]');
          btn.classList.remove('tw-border-[#E6E6E6]');
        } else {
          // This is an inactive tab
          btn.classList.remove('tw-border-[#1c1d1d]');
          btn.classList.add('tw-border-[#E6E6E6]');
        }
      });

      // Trigger gallery resize for the new section
      window.dispatchEvent(new Event("resize"));
    });
  });

  // --- 2. DISABLE OOS VARIANTS ON LOAD ---
  const productForms = document.querySelectorAll('[id^="AddToCartForm-"]');
  productForms.forEach((form) => {
    const sectionId = form.getAttribute("data-productid");
    const jsonEl = form.querySelector(`#StandardVariantsJson-${sectionId}`);
    if(jsonEl) {
       const productData = JSON.parse(jsonEl.textContent);
       const variantButtons = form.querySelectorAll(".variant-input label");
       variantButtons.forEach((button) => {
         const input = button.closest(".variant-input").querySelector("input");
         if(input) {
            const vData = productData.find(v => v.title === input.value);
            if (vData && !vData.available) {
              input.disabled = true;
              button.classList.add("disabled");
            }
         }
       });
    }
  });

  // --- 3. CUSTOM UI LOGIC ---
  function formatMoney(cents) {
    return "$" + (parseInt(cents) / 100).toFixed(2);
  }

  productForms.forEach(form => {
     const stdCard = form.querySelector('.ub-card[data-card="standard"]');
     const ultCard = form.querySelector('.ub-card[data-card="ultimate"]');
     const toggleWrap = form.querySelector('.ub-toggle-wrapper');
     const banner = form.querySelector('.ub-sub-banner');

    function updateActiveCard(cardType) {
        if(cardType === 'standard') {
            stdCard.classList.add('is-selected');
            ultCard.classList.remove('is-selected');
        } else {
            stdCard.classList.remove('is-selected');
            ultCard.classList.add('is-selected');
        }
        updateSubContentVisibility();

        // --- GALLERY SWAPPING & SLIDER INITIALIZATION ---
        const sectionEl = form.closest('.product-section');
        if (sectionEl) {
            const stdGallery = sectionEl.querySelector('.ub-gallery[data-gallery-type="standard"]');
            const ultGallery = sectionEl.querySelector('.ub-gallery[data-gallery-type="ultimate"]');
            
            if (cardType === 'standard') {
                if (stdGallery) stdGallery.classList.add('is-active');
                if (ultGallery) ultGallery.classList.remove('is-active');
            } else {
                if (stdGallery) stdGallery.classList.remove('is-active');
                if (ultGallery) ultGallery.classList.add('is-active');

                // Theme Compatibility: Manually initialize the Ultimate Slider if it hasn't been built yet
                if (ultGallery) {
                    const ultSliderEl = ultGallery.querySelector('.product-slideshow');
                    
                    // Check if it's already initialized (Flickity adds 'flickity-enabled' class)
                    if (ultSliderEl && !ultSliderEl.classList.contains('flickity-enabled') && window.theme && window.theme.Slideshow) {
                        const ultThumbsEl = ultGallery.querySelector('.product__thumbs');
                        const ultThumbsScroller = ultGallery.querySelector('.product__thumbs--scroller');
                        
                        // Boot up the theme's native slider script
                        new window.theme.Slideshow(ultSliderEl, {
                            adaptiveHeight: true,
                            avoidReflow: true,
                            initialIndex: 0,
                            childNav: ultThumbsEl,
                            childNavScroller: ultThumbsScroller,
                            childVertical: ultThumbsEl ? ultThumbsEl.dataset.position === 'beside' : false,
                            wrapAround: false
                        });
                        
                        // Initialize Image Zoom (Photoswipe)
                        const ultImageContainer = ultGallery.querySelector('[data-product-images]');
                        const ultProductId = ultGallery.getAttribute('data-product-id');
                        if (ultImageContainer && window.theme.Photoswipe) {
                            new window.theme.Photoswipe(ultImageContainer, ultProductId);
                        }
                    }
                }
            }
            
            // Force browser and Flickity to recalculate dimensions so images aren't squished
            window.dispatchEvent(new Event("resize"));
            setTimeout(() => window.dispatchEvent(new Event("resize")), 100); // Failsafe for slow renders
            
            if (window.Flickity) {
               sectionEl.querySelectorAll('.flickity-enabled').forEach(s => {
                   const flkty = window.Flickity.data(s);
                   if (flkty) flkty.resize();
               });
            }
        }
     }

     function updateSubContentVisibility() {
        const isSub = toggleWrap.classList.contains('is-on');
        const subLabel = document.querySelector('.ub-toggle-sublabel');

        form.querySelectorAll('.ub-sub-content').forEach(el => el.classList.add('tw-hidden'));
        form.querySelectorAll('.ub-label--sub').forEach(el => el.classList.toggle('tw-hidden', !isSub));
        form.querySelectorAll('.ub-label--onetime').forEach(el => el.classList.toggle('tw-hidden', isSub));
        form.querySelectorAll('.ub-compare-price').forEach(el => el.style.display = isSub ? 'block' : 'none');

        if(banner) banner.style.display = isSub ? 'block' : 'none';
        if(isSub) {
            const activeCardEl = stdCard.classList.contains('is-selected') ? stdCard : ultCard;
            const subContent = activeCardEl.querySelector('.ub-sub-content');
            if(subContent) subContent.classList.remove('tw-hidden');
            form.querySelectorAll('.ub-price').forEach(el => {
                const customSub = el.getAttribute('data-custom-sub');
                el.textContent = customSub ? customSub : formatMoney(el.getAttribute('data-sub'));
            });
        } else {
            form.querySelectorAll('.ub-price').forEach(el => {
                const customOneTime = el.getAttribute('data-custom-onetime');
                el.textContent = customOneTime ? customOneTime : formatMoney(el.getAttribute('data-onetime'));
            });
        }
     }

     if(stdCard) stdCard.addEventListener('click', () => updateActiveCard('standard'));
     if(ultCard) ultCard.addEventListener('click', () => updateActiveCard('ultimate'));

     if(toggleWrap) {
         toggleWrap.addEventListener('click', (e) => {
             toggleWrap.classList.toggle('is-on');
             updateSubContentVisibility();
         });
     }

     form.querySelectorAll('.ub-freq-tile').forEach(tile => {
        tile.addEventListener('click', (e) => {
            e.stopPropagation();
            const container = tile.closest('.ub-freq-tiles');
            container.querySelectorAll('.ub-freq-tile').forEach(t => t.classList.remove('is-active'));
            tile.classList.add('is-active');
        });
     });
  });

// --- 4. THEME VARIANT CHANGE INTERCEPT ---
    document.addEventListener("variant:change", (event) => {
      const variant = event.detail.variant;
      const form = event.target ? event.target.closest('form') : null;
      if(!form || !variant) return;

      const sectionId = form.getAttribute("data-productid");

      // Standard Prices
      const stdPriceEl = form.querySelector('.ub-card[data-card="standard"] .ub-price');
      const stdCompareEl = form.querySelector('.ub-card[data-card="standard"] .ub-compare-price');
      if(stdPriceEl) {
          stdPriceEl.setAttribute('data-onetime', variant.price);
          let subPrice = variant.price;
          if(variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
              subPrice = variant.selling_plan_allocations[0].price;
          }
          stdPriceEl.setAttribute('data-sub', subPrice);
          const isSubOn = form.querySelector('.ub-toggle-wrapper').classList.contains('is-on');
          
          const customSub = stdPriceEl.getAttribute('data-custom-sub');
          const customOneTime = stdPriceEl.getAttribute('data-custom-onetime');
          const customComp = stdCompareEl ? stdCompareEl.getAttribute('data-custom-comp') : null;

          stdPriceEl.textContent = isSubOn 
              ? (customSub ? customSub : formatMoney(subPrice)) 
              : (customOneTime ? customOneTime : formatMoney(variant.price));
              
          if(stdCompareEl) stdCompareEl.textContent = customComp ? customComp : formatMoney(variant.price);
      }

      // Ultimate Prices
      const ultVariantsJson = form.querySelector(`#UltimateVariantsJson-${sectionId}`);
      if(ultVariantsJson) {
          const ultVariants = JSON.parse(ultVariantsJson.textContent);
          const ultVariant = ultVariants.find(v => v.title === variant.title);
          if(ultVariant) {
              const ultPriceEl = form.querySelector('.ub-card[data-card="ultimate"] .ub-price');
              const ultCompareEl = form.querySelector('.ub-card[data-card="ultimate"] .ub-compare-price');
              if(ultPriceEl) {
                  ultPriceEl.setAttribute('data-onetime', ultVariant.price);
                  let uSubPrice = ultVariant.price;
                  if(ultVariant.selling_plan_allocations && ultVariant.selling_plan_allocations.length > 0) {
                      uSubPrice = ultVariant.selling_plan_allocations[0].price;
                  }
                  ultPriceEl.setAttribute('data-sub', uSubPrice);
                  const isSubOn = form.querySelector('.ub-toggle-wrapper').classList.contains('is-on');
                  
                  const customSub = ultPriceEl.getAttribute('data-custom-sub');
                  const customOneTime = ultPriceEl.getAttribute('data-custom-onetime');
                  const customComp = ultCompareEl ? ultCompareEl.getAttribute('data-custom-comp') : null;

                  ultPriceEl.textContent = isSubOn 
                      ? (customSub ? customSub : formatMoney(uSubPrice)) 
                      : (customOneTime ? customOneTime : formatMoney(ultVariant.price));
                      
                  if(ultCompareEl) ultCompareEl.textContent = customComp ? customComp : formatMoney(ultVariant.price);
              }
          }
      }
  });

  // --- 5. MODAL INTERCEPT & AIRTIGHT CART SUBMISSION ---
  const modal = document.getElementById("additional-options-modal");
  const additionalOptionsForm = document.getElementById("additional-options-form");
  let currentSubmittingForm = null;

  const addToCartForms = document.querySelectorAll("form[action^='/cart/add']");
  addToCartForms.forEach((form) => {
    form.addEventListener("submit", (event) => {
      // If the modal already validated this, let the theme submit normally (opens AJAX drawer)
      if (form.dataset.readyToSubmit === "true") {
          form.dataset.readyToSubmit = "false"; // Reset for next time
          return;
      }
      
      event.preventDefault(); // Stop standard submit
      currentSubmittingForm = form;
      if(additionalOptionsForm) additionalOptionsForm.reset();
      if(modal) modal.classList.remove("tw-hidden");
    });
  });

  document.getElementById("cancel-options").addEventListener("click", () => {
    modal.classList.add("tw-hidden");
  });

  if(additionalOptionsForm) {
      additionalOptionsForm.addEventListener("submit", (e) => {
        e.preventDefault();
        if(!currentSubmittingForm) return;

        const sectionId = currentSubmittingForm.getAttribute("data-productid");

        // 1. Read the EXACT selected size from the visible buttons
        const checkedRadio = currentSubmittingForm.querySelector('.variant-input input[type="radio"]:checked');
        const stdVariants = JSON.parse(currentSubmittingForm.querySelector(`#StandardVariantsJson-${sectionId}`).textContent);
        const ultVariants = JSON.parse(currentSubmittingForm.querySelector(`#UltimateVariantsJson-${sectionId}`).textContent);
        
        let selectedSizeTitle = checkedRadio ? checkedRadio.value : stdVariants[0].title;

        // 2. Identify the active choices
        const isUltimate = currentSubmittingForm.querySelector('.ub-card[data-card="ultimate"]').classList.contains('is-selected');
        const isSubOn = currentSubmittingForm.querySelector('.ub-toggle-wrapper').classList.contains('is-on');

        // 3. Match the variant based on Size and Product Type (Standard vs Ultimate)
        const stdVariant = stdVariants.find(v => v.title === selectedSizeTitle);
        // const ultVariant = ultVariants.find(v => v.title === selectedSizeTitle);
        const finalVariant = isUltimate ? ultVariant : stdVariant;

        // --- CRITICAL OOS CHECK ---
        if (!finalVariant || !finalVariant.available) {
            alert("Sorry, the selected size is out of stock in this box type. Please choose a different size.");
            hide(modal);
            return; // STOP SUBMISSION
        }

        let finalVariantId = finalVariant.id;
        let finalPlanId = "";

        // 4. Extract Subscription Selling Plan
        if (isSubOn) {
            const planType = isUltimate ? "ultimate" : "standard";
            const activeTile = currentSubmittingForm.querySelector(`.ub-freq-tiles[data-product-type="${planType}"] .ub-freq-tile.is-active`);
            if(activeTile) {
                finalPlanId = activeTile.getAttribute('data-plan-id');
            }
        }

        // 5. Inject properties for the Modal Selections
        const selectedNations = Array.from(document.querySelectorAll('input[name="nations_leagues"]:checked')).map(cb => cb.value);
        currentSubmittingForm.querySelector(`#nations-leagues_${sectionId}`).value = selectedNations.join(", ");
        currentSubmittingForm.querySelector(`#specific-teams_${sectionId}`).value = document.getElementById("specific-teams").value;
        currentSubmittingForm.querySelector(`#additional-info-field_${sectionId}`).value = document.getElementById("additional-info").value;

        // 6. INJECT EXACT CART PAYLOAD
        const planInput = currentSubmittingForm.querySelector(`#selling-plan-field_${sectionId}`);
        if (planInput) {
            if (finalPlanId && isSubOn) {
                planInput.value = finalPlanId;
                planInput.disabled = false;
            } else {
                planInput.value = "";
                planInput.disabled = true; // Disabled so Shopify doesn't see a blank selling plan
            }
        }

        // Disable the theme's default variant select so it doesn't override us
        const masterSelect = currentSubmittingForm.querySelector(`#ProductSelect-${sectionId}`);
        if (masterSelect) masterSelect.disabled = true; 

        // Add our strict custom ID field
        let customIdInput = currentSubmittingForm.querySelector('input[name="id"].custom-id');
        if(!customIdInput) {
            customIdInput = document.createElement('input');
            customIdInput.type = 'hidden';
            customIdInput.name = 'id';
            customIdInput.className = 'custom-id';
            currentSubmittingForm.appendChild(customIdInput);
        }
        customIdInput.value = finalVariantId;
        customIdInput.disabled = false;

        // 7. HIDE MODAL AND TRIGGER NATIVE CART / CHECKOUT
        modal.classList.add("tw-hidden");

        const directCheckout = currentSubmittingForm.getAttribute('data-direct-checkout') === 'true';

        if (directCheckout) {
            // Direct to Checkout Flow
            let returnToInput = currentSubmittingForm.querySelector('input[name="return_to"]');
            if (!returnToInput) {
                returnToInput = document.createElement('input');
                returnToInput.type = 'hidden';
                returnToInput.name = 'return_to';
                currentSubmittingForm.appendChild(returnToInput);
            }
            returnToInput.value = '/checkout';
            HTMLFormElement.prototype.submit.call(currentSubmittingForm);
        } else {
            // AJAX Cart Drawer Flow
            currentSubmittingForm.dataset.readyToSubmit = "true";
            const submitBtn = currentSubmittingForm.querySelector('button[name="add"]');
            if(submitBtn) {
                submitBtn.click();
            } else {
                HTMLFormElement.prototype.submit.call(currentSubmittingForm);
            }
        }
      });
  }
});